import { AfterViewInit, Component, ElementRef, Input, OnChanges, ViewChild } from '@angular/core';
import { TreeViewItem } from '../../models/tree-view-item.interface';
import { TreeViewItemComponent } from '../tree-view-item/tree-view-item.component';
import { IconComponent } from '@aft/frogo-kit/components/icon/icon.component';
import { DropdownDirective } from '@aft/frogo-kit/directives/dropdown.directive';

@Component({
  selector: 'fk-tree-view-group',
  templateUrl: './tree-view-group.component.html',
  styleUrls: ['./tree-view-group.component.scss'],
  imports: [TreeViewItemComponent, IconComponent, DropdownDirective],
})
export class TreeViewGroupComponent implements OnChanges, AfterViewInit {
  @Input()
  item!: TreeViewItem;

  @Input()
  isLastItem = false;

  @Input()
  isRootItem = false;

  @Input()
  minimized = false;

  @ViewChild('treeViewGroup')
  protected treeViewGroupRef!: ElementRef;

  protected collapsed = false;

  ngOnChanges(): void {
    if (this.minimized) {
      this.collapsed = true;
    } else {
      this.expandSelectedGroup();
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.expandSelectedGroup();
    }, 0);
  }

  expandSelectedGroup(): void {
    if (this.treeViewGroupRef) {
      const selectedEl = this.treeViewGroupRef.nativeElement.querySelector('.fk-tree-view-item--link__active');

      this.collapsed = Boolean(!selectedEl);
    }
  }

  protected isGroup(item: TreeViewItem): boolean {
    return Boolean(item.items);
  }

  protected toggleSubTreeVisibility() {
    if (!this.minimized) {
      this.collapsed = !this.collapsed;
    }
  }

  protected mouseEnterGroupHeader(): void {
    if (this.minimized) {
      this.collapsed = false;
    }
  }

  protected mouseLeaveGroupHeader(): void {
    if (this.minimized) {
      this.collapsed = true;
    }
  }

  protected toggleGroupHeader(e: Event): void {
    e.stopPropagation();

    if (this.minimized) {
      this.collapsed = !this.collapsed;
    }
  }
}
